import React from 'react'
import {
  NavigationLocation,
  NextpageContext,
  NextPageService,
} from "@cvx/nextpage-react";
import { Link } from 'react-router-dom'
// Define NextPageRoute type if not exported from @cvx/nextpage-react
type NextPageRoute = {
  url: string;
  title: string;
  megaMenu?: any;
  children?: NextPageRoute[];
};

class GlobalMainNavObject {
  label: string = ''
  navItems: Array<{
    url?: string
    subnavUrl?: string
    megaMenu?: any
    title: string
  }> = []
}

class GlobalSubNavObject extends GlobalMainNavObject {
  navParentUrl: string = ''
  topLevelPath: string = ''
}

export type IMenuProps = {
  location: NavigationLocation
  navStartUrl?: string
  sideNavTitle?: string
  nextPage?: NextPageService
}

interface IMenuState {}

let menu: any = null
let globalMainNav: GlobalMainNavObject = new GlobalMainNavObject()
let globalSubNavs: Array<GlobalSubNavObject> = [new GlobalSubNavObject()]
let routes: NextPageRoute[] = []

class Menu extends React.Component<IMenuProps, IMenuState> {
  static contextType = NextpageContext

  constructor(props: IMenuProps) {
    super(props)
    const nextpage: any = this.props.nextPage
    routes = nextpage.options.navigationRoutes

    switch (this.props.location) {
      case NavigationLocation.Global:
        this.setGlobalMainNav()
        nextpage.UI.registerEvent('topMenuClick', () => {})
        menu = this.createGlobalNav()
        break
      case NavigationLocation.SiteSpecific:
        const subNavs = this.createSubNavs()
        menu = (
          <nav id='site-specific-nav'>
            <ul>{subNavs}</ul>
          </nav>
        )
        break
      case NavigationLocation.Side:
        const sideNavs = this.createSideNavs(nextpage)
        let title = ''
        for (let route of routes) {
          if (route.url === this.props.navStartUrl) {
            title = route.title
          }
        }
        menu = (
          <nav id='left-nav' data-start-url={this.props.navStartUrl} className='row'>
            <div className='col'>
              <h4>{this.props.sideNavTitle || title}</h4>
              <ul>{sideNavs}</ul>
            </div>
          </nav>
        )
        break
    }
  }

  componentDidMount() {
    const nextpage = this.context as NextPageService
    switch (this.props.location) {
      case NavigationLocation.Global:
        nextpage.UI.components.globalTopMenu()
        break
      case NavigationLocation.SiteSpecific:
        const mains = document.querySelectorAll('main.container')
        if (mains.length !== 0) {
          nextpage.UI.components.layoutMorphs(nextpage.properties)
          nextpage.UI.layout.layoutMorphs(nextpage.properties)
        }
        break
      case NavigationLocation.Side:
        break
    }

    const mainContainer = document.querySelectorAll('main.container')
    if (mainContainer.length !== 0) {
      nextpage.UI.components.layoutMorphs(nextpage.properties)
      nextpage.UI.layout.layoutMorphs(nextpage.properties)
    }
  }

  render() {
    return <>{menu}</>
  }

  private createGlobalNav() {
    return (
      <>
        <div id='toggle-menu' className='topmenu' role='button' aria-label='Toggle top menu navigation' aria-pressed='false'>
          <span className='icon-menu-hamburger'>
            <em>menu</em>
          </span>
          <span className='icon-remove'></span>
        </div>
        <div className='headernav' id='top-menu' onClick={e => e.nativeEvent.stopImmediatePropagation()}>
          <div id='nav-container'>
            <nav className='mainnav' aria-hidden='false'>
              <ul>
                {globalMainNav.navItems.map((navItem, i) => (
                  <React.Fragment key={i}>
                    {!navItem.subnavUrl && (
                      <li>
                        <Link to={navItem.url!}>{navItem.title}</Link>
                      </li>
                    )}
                    {!navItem.url && (
                      <li data-subnav={navItem.subnavUrl}>
                        {navItem.title}
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </nav>
            <>
              {globalSubNavs.map((subnav, i) => (
                <nav
                  className='subnav aria-hidden'
                  data-nav-parent={subnav.navParentUrl}
                  data-nav-top-level={subnav.topLevelPath}
                  aria-hidden={true}
                  key={i}
                >
                  <ul>
                    <li className='previous'>previous menu</li>
                    {subnav.topLevelPath !== subnav.navParentUrl && (
                      <li className='parent-link'>
                        <Link to={`/${subnav.topLevelPath}/${subnav.navParentUrl}`}>
                          {subnav.label}
                        </Link>
                      </li>
                    )}
                    {subnav.topLevelPath === subnav.navParentUrl && (
                      <li className='parent-link'>
                        <Link to={`/${subnav.navParentUrl}`}>
                          {subnav.label}
                        </Link>
                      </li>
                    )}
                    {subnav.navItems.map((subnavItem, j) => (
                      <React.Fragment key={j}>
                        {!subnavItem.subnavUrl && (
                          <li>
                            <Link to={`${subnavItem.url}`}>
                              {subnavItem.title}
                            </Link>
                          </li>
                        )}
                        {!subnavItem.url && (
                          <li data-subnav={subnavItem.subnavUrl}>
                            {subnavItem.title}
                          </li>
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                </nav>
              ))}
            </>
          </div>
          <hr className='separator' />
          <h3>quick links</h3>
          <hr className='separator' />
          <ul>
            <li>
              <a href='https://www.timeanddate.com/worldclock/' target='_blank' rel='noopener noreferrer'>world clock</a>
            </li>
            <li>
              <a href='https://www.wunderground.com/' target='_blank' rel='noopener noreferrer'>weather</a>
            </li>
            <li>
              <a href='https://www.chevron.com/' target='_blank' rel='noopener noreferrer'>chevron.com</a>
            </li>
          </ul>
        </div>
      </>
    )
  }

  private createSubNavs() {
    return routes.map((route, i) => (
      <li key={route.title}>
        <Link to={`/${route.url}`}>{route.title}</Link>
        {route.megaMenu && (
          <div className='mega-menu'>
            <div className='row'>
              {route.children?.map((child, j) => (
                <div className={`col-` + route.megaMenu?.columnSize} key={j}>
                  <Link to={`/${route.url}/${child.url}`}>
                    <h3>{child.title}</h3>
                  </Link>
                  <ul className='in-mega'>
                    {child.children?.map((grandChild, k) => (
                      <li key={k}>
                        <Link to={`/${route.url}/${child.url}/${grandChild.url}`}>
                          {grandChild.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
        {route.children?.length! > 0 && !route.megaMenu && (
          <ul>
            {route.children?.map((child, j) => (
              <li key={child.title}>
                <Link to={`/${route.url}/${child.url}`}>{child.title}</Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))
  }

  private createSideNavs(nextpage: any) {
    return routes.map((route, i) => (
      <li key={route.title} id='route-nav' className={`${route.children ? 'children' : ''}`}>
        {route.children && (
          <span className='nav-toggle' onClick={nextpage.UI.events.detailPageNavigationToggleClick}></span>
        )}
        <Link to={this.props.navStartUrl ? route.url : `/${route.url}`}>{route.title}</Link>
        {route.children && (
          <ul>
            {this.mapSideNavRouteChildren(route)}
          </ul>
        )}
      </li>
    ))
  }

  private mapSideNavRouteChildren(route: NextPageRoute) {
    return route.children?.map((child, j) => (
      <li key={child.title}>
        <Link to={`/${route.url}/${child.url}`}>{child.title}</Link>
      </li>
    ))
  }

  private setGlobalMainNav() {
    const nextpage = this.props.nextPage!
    const topNav = new GlobalMainNavObject()
    let subNavList = new Array<GlobalSubNavObject>()
    topNav.label = nextpage.options.sitename
    topNav.navItems = []
    for (const menuItem of nextpage.options.navigationRoutes) {
      if (!menuItem.url.length || menuItem.title === undefined) continue
      if (!menuItem.children || menuItem.children.length === 0) {
        topNav.navItems.push({
          title: menuItem.title,
          url: menuItem.url,
          megaMenu: menuItem.megaMenu || null
        })
        continue
      }
      topNav.navItems.push({
        title: menuItem.title,
        subnavUrl: menuItem.url
      })
      const newSubNavs = this.getSubNavs(
        menuItem.url,
        menuItem.title,
        menuItem.children,
        menuItem.url
      )
      subNavList = subNavList.concat(newSubNavs)
    }
    globalMainNav = topNav
    globalSubNavs = subNavList
  }

  private getSubNavs(
    parentUrl: string,
    parentLabel: string,
    menuChildren: NextPageRoute[],
    topLevelPath: string
  ) {
    const newSubNav = new GlobalSubNavObject()
    let subNavList = new Array<GlobalSubNavObject>()
    newSubNav.label = parentLabel
    newSubNav.navParentUrl = parentUrl
    newSubNav.topLevelPath = topLevelPath
    newSubNav.navItems = []
    this.setSubNavChildren(parentUrl, menuChildren, topLevelPath, newSubNav, subNavList)
    return subNavList.length === 0 ? [newSubNav] : [newSubNav].concat(subNavList)
  }

  private setSubNavChildren(
    parentUrl: string,
    menuChildren: NextPageRoute[],
    topLevelPath: string,
    newSubNav: GlobalSubNavObject,
    subNavList: Array<GlobalSubNavObject>
  ) {
    for (const menuItem of menuChildren) {
      if (!menuItem.url.length || menuItem.title === undefined) continue
      if (menuItem) {
        if (!menuItem.children || menuItem.children.length === 0) {
          this.addMenuChildrenToSubNav(topLevelPath, parentUrl, newSubNav, menuItem)
          continue
        }
        newSubNav.navItems.push({
          title: menuItem.title,
          subnavUrl: menuItem.url
        })
        subNavList = subNavList.concat(this.getSubNavs(
          menuItem.url,
          menuItem.title,
          menuItem.children,
          topLevelPath
        ))
      }
    }
  }

  private addMenuChildrenToSubNav(
    topLevelPath: string,
    parentUrl: string,
    newSubNav: GlobalSubNavObject,
    menuItem: NextPageRoute
  ) {
    if (topLevelPath === parentUrl) {
      newSubNav.navItems.push({
        title: menuItem.title,
        url: `/${parentUrl}/${menuItem.url}`,
        megaMenu: menuItem.megaMenu || null
      })
    } else {
      newSubNav.navItems.push({
        title: menuItem.title,
        url: `/${topLevelPath}/${parentUrl}/${menuItem.url}`,
        megaMenu: menuItem.megaMenu || null
      })
    }
  }
}

export default Menu